import { useSelector } from "react-redux";
import store from "../../stores/store";
import FeaturesTable from "../controls/featuresTable";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { useEffect } from "react";
import { formatSelectedFeatures, key, trans } from "../../lib/utils";
import BootstrapTable from "react-bootstrap-table-next";
import { getLayerById } from "../map/mapUtils";
import { showFeature } from "../../lib/featureUtils";

function EditPanel() {
  const editHistory = useSelector((state) => store.getState().edit.history);

  const editCopied = useSelector((state) => store.getState().edit.copied);

  const results = useSelector((state) => store.getState().results);

  const selectedLayer = useSelector((state) => store.getState().edit.editLayer);

  const activeTab = results.resultsPanelActiveTab;

  useEffect(() => {
    window["recaclulatePerfectScrollbarHeight"]();
  }, []);

  return (
    <>
      <PerfectScrollbar style={{ height: "45px" }}>
        <ul className="nav nav-tabs navbar-expand small">
          <li
            className="nav-item "
            role="button"
            onClick={() => {
              window["recaclulatePerfectScrollbarHeight"]();
            }}
          >
            <span
              className={"nav-link color-strong-grey nav-ellipsis  ".concat(
                activeTab.startsWith("edit-copy") ? "active" : ""
              )}
              onClick={() => {
                store.dispatch({
                  type: "results/setActiveTab",
                  payload: "edit-copy",
                });
              }}
            >
              <span className="color-black">
                {trans("Copied features").concat(" (", editCopied?.length, ")")}
              </span>
            </span>
          </li>
          <li
            className="nav-item "
            role="button"
            onClick={() => {
              window["recaclulatePerfectScrollbarHeight"]();
            }}
          >
            <span
              className={"nav-link color-strong-grey nav-ellipsis  ".concat(
                activeTab.startsWith("edit-history") ? "active" : ""
              )}
              onClick={() => {
                store.dispatch({
                  type: "results/setActiveTab",
                  payload: "edit-history",
                });
              }}
            >
              <span className="color-black">
                {trans("History").concat(" (", editHistory?.length, ")")}
              </span>
            </span>
          </li>
        </ul>
      </PerfectScrollbar>
      <div className="tab-content ">
        <div
          className={"tab-pane fade ".concat(
            activeTab.startsWith("edit-copy") ? "show active" : ""
          )}
          role="tabpanel"
        >
          <PerfectScrollbar className="scrollbar-recaclulate">
            <BootstrapTable
              key={key()}
              keyField="index"
              data={
                editCopied
                  ? editCopied?.map((el, idx) => {
                      return el;
                    })
                  : []
              }
              columns={[
                {
                  dataField: "_zoomToFeature",
                  text: "",
                  headerStyle: (colum, colIndex) => {
                    return { width: "30px", textAlign: "center" };
                  },
                  formatter: function (cell, row) {
                    return (
                      <i
                        className="fas fa-compress  m-auto"
                        role="button"
                        onClick={(e) => {
                          showFeature(row._feature);
                        }}
                      ></i>
                    );
                  },
                },
                {
                  dataField: "_paste",
                  text: "",
                  headerStyle: (colum, colIndex) => {
                    return { width: "30px", textAlign: "center" };
                  },
                  formatter: function (cell, row) {
                    return (
                      <i
                        className="fas fa-paste  m-auto"
                        role="button"
                        onClick={(e) => {
                          let copiedFeature = row.feature;

                          copiedFeature.setId(key());

                          getLayerById(selectedLayer)
                            .getSource()
                            .addFeature(copiedFeature);
                        }}
                      ></i>
                    );
                  },
                },
                {
                  dataField: "layerName",
                  text: trans("Layer Name"),
                },
                {
                  dataField: "layerTitle",
                  text: trans("Layer Title"),
                },
                {
                  dataField: "featureId",
                  text: trans("Feature id"),
                },
              ]}
              wrapperClasses="bg-white"
              striped
              hover
            />
          </PerfectScrollbar>
        </div>
        <div
          className={"tab-pane fade ".concat(
            activeTab.startsWith("edit-history") ? "show active" : ""
          )}
          role="tabpanel"
        >
          <PerfectScrollbar className="scrollbar-recaclulate">
            <BootstrapTable
              key={key()}
              keyField="index"
              data={
                editHistory
                  ? editHistory?.map((el, idx) => {
                      el.index = idx;
                      return el;
                    })
                  : []
              }
              columns={[
                {
                  dataField: "type",
                  text: trans("Type"),
                },
                {
                  dataField: "featureId",
                  text: trans("Feature id"),
                },
                {
                  dataField: "index",
                  text: trans("Index"),
                },
              ]}
              wrapperClasses="bg-white"
              striped
              hover
            />
          </PerfectScrollbar>
        </div>
      </div>
    </>
  );
}

export default EditPanel;
